export const T_AND_C_TERMS =
  'https://aws.amazon.com/legal/learner-terms-conditions/';

export const T_AND_C_PRIVACY =
  'https://aws.amazon.com/privacy/?src=aws_training';
